export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/prevBtn.8f406806.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};